import { Badge } from '@/components/ui/badge'
import { SupportThreadStatus } from '@/gen/cortado/v1/support_pb'

function getStatusVariant(status: SupportThreadStatus) {
  switch (status) {
    case SupportThreadStatus.NEW:
      return 'secondary' as const
    case SupportThreadStatus.IN_PROGRESS:
      return 'info' as const
    case SupportThreadStatus.RESOLVED:
      return 'success' as const
    default:
      return 'secondary' as const
  }
}

function getStatusLabel(status: SupportThreadStatus) {
  switch (status) {
    case SupportThreadStatus.NEW:
      return 'New'
    case SupportThreadStatus.IN_PROGRESS:
      return 'In Progress'
    case SupportThreadStatus.RESOLVED:
      return 'Resolved'
    default:
      return 'Unknown'
  }
}

export function StatusBadge({ status }: { status: SupportThreadStatus }) {
  return (
    <Badge variant={getStatusVariant(status)}>
      {getStatusLabel(status)}
    </Badge>
  )
}
